module.exports = __webpack_public_path__ + "static/media/18ECA20.0edfd1f3.jpg";